import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import MetadataLinkTooltipBox from "components/Common/MetadataLinkTooltipBox";

const DEFAULT_MAX_LABEL_LENGTH = 48;

const truncateLinkLabel = (url = "", maxLength = DEFAULT_MAX_LABEL_LENGTH) => {
  const value = String(url ?? "").trim();
  if (!value) return "";
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength)}…`;
};

const MetadataLinkTableCell = ({ url = "", columnTitle = "Link", maxLabelLength }) => {
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const normalizedUrl = String(url ?? "").trim();

  if (!normalizedUrl) {
    return <span className="text-muted">—</span>;
  }

  const toggle = () => setIsOpen((open) => !open);

  return (
    <span className="metadata-link-table-cell">
      <button
        ref={triggerRef}
        type="button"
        className="btn btn-link p-0 text-decoration-none metadata-link-table-cell__trigger"
        onClick={(event) => {
          event.stopPropagation();
          toggle();
        }}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        {truncateLinkLabel(
          normalizedUrl,
          maxLabelLength ?? DEFAULT_MAX_LABEL_LENGTH
        )}
      </button>
      <MetadataLinkTooltipBox
        isOpen={isOpen}
        toggle={toggle}
        targetRef={triggerRef}
        url={normalizedUrl}
        title={columnTitle}
      />
    </span>
  );
};

MetadataLinkTableCell.propTypes = {
  url: PropTypes.string,
  columnTitle: PropTypes.string,
  maxLabelLength: PropTypes.number,
};

export default MetadataLinkTableCell;
